// @flow

import type {
  IDString,
  IDNumber,
  Shift,
  LogInResponse,
  TimeClockStateSettings,
  SetTimeClockDataAction,
  ClearTimeClockDataAction,
  GetTimeClockStateAction,
  UpdateShiftListAction,
  UpdateShiftAction,
  ClockInAction,
  ClockInSuccessAction,
  StartBreakAction,
  StartAutomatedBreakAction,
  StartBreakSuccessAction,
  EndBreakAction,
  EndBreakSuccessAction,
  ClockOutAction,
  ClockOutSuccessAction,
  StartAdHocClockInAction,
  AdHocClockInAction,
  AdHocClockInSuccessAction,
  GetTimeClockStateFinishedAction,
  AddOrEditTimeclockNoteAction,
  AddOrEditTimeclockNoteSuccessAction,
  SetHideGreetingAction,
  ClockOutWithAttestationsAction
} from '../common/typings';

export const SET_TIME_CLOCK_DATA = 'SET_TIME_CLOCK_DATA';
export const CLEAR_TIME_CLOCK_DATA = 'CLEAR_TIME_CLOCK_DATA';
export const GET_TIME_CLOCK_STATE = 'GET_TIME_CLOCK_STATE';
export const UPDATE_SHIFT_LIST = 'UPDATE_SHIFT_LIST';
export const UPDATE_SHIFT = 'UPDATE_SHIFT';
export const CLOCK_IN = 'CLOCK_IN';
export const CLOCK_IN_SUCCESS = 'CLOCK_IN_SUCCESS';
export const START_BREAK = 'START_BREAK';
export const START_BREAK_SUCCESS = 'START_BREAK_SUCCESS';
export const START_AUTOMATED_BREAK = 'START_AUTOMATED_BREAK';
export const END_BREAK = 'END_BREAK';
export const END_BREAK_SUCCESS = 'END_BREAK_SUCCESS';
export const CLOCK_OUT = 'CLOCK_OUT';
export const CLOCK_OUT_SUCCESS = 'CLOCK_OUT_SUCCESS';
export const START_AD_HOC_CLOCK_IN = 'START_AD_HOC_CLOCK_IN';
export const AD_HOC_CLOCK_IN = 'AD_HOC_CLOCK_IN';
export const AD_HOC_CLOCK_IN_SUCCESS = 'AD_HOC_CLOCK_IN_SUCCESS';
export const GET_TIME_CLOCK_STATE_FINISHED = 'GET_TIME_CLOCK_STATE_FINISHED';
export const ADD_OR_EDIT_TIMECLOCK_NOTE = 'ADD_OR_EDIT_TIMECLOCK_NOTE';
export const ADD_OR_EDIT_TIMECLOCK_NOTE_SUCCESS = 'ADD_OR_EDIT_TIMECLOCK_NOTE_SUCCESS';
export const SET_HIDE_GREETING = 'SET_HIDE_GREETING';
export const CLOCK_OUT_WITH_ATTESTATIONS = 'CLOCK_OUT_WITH_ATTESTATIONS';

export function setTimeClockData(data: LogInResponse): SetTimeClockDataAction {
  return {
    type: SET_TIME_CLOCK_DATA,
    payload: {
      data
    }
  };
}

export function clearTimeClockData(): ClearTimeClockDataAction {
  return {
    type: CLEAR_TIME_CLOCK_DATA
  };
}

export function getTimeClockState(
  orgId: number,
  settings: TimeClockStateSettings
): GetTimeClockStateAction {
  return {
    type: GET_TIME_CLOCK_STATE,
    payload: {
      orgId,
      settings
    }
  };
}

export function updateShiftList(shifts: Array<Shift>): UpdateShiftListAction {
  return {
    type: UPDATE_SHIFT_LIST,
    payload: {
      shifts
    }
  };
}

export function updateShift(shift: Shift): UpdateShiftAction {
  return {
    type: UPDATE_SHIFT,
    payload: {
      shift
    }
  };
}

export function clockIn(shiftId: IDString): ClockInAction {
  return {
    type: CLOCK_IN,
    payload: {
      shiftId
    }
  };
}

export function clockInSuccess(shift: Shift): ClockInSuccessAction {
  return {
    type: CLOCK_IN_SUCCESS,
    payload: {
      shift
    }
  };
}

export function startBreak(): StartBreakAction {
  return {
    type: START_BREAK
  };
}

export function startBreakSuccess(shift: Shift): StartBreakSuccessAction {
  return {
    type: START_BREAK_SUCCESS,
    payload: {
      shift
    }
  };
}

export function startAutomatedBreak(automatedBreakType: string): StartAutomatedBreakAction {
  return {
    type: START_AUTOMATED_BREAK,
    payload: { automatedBreakType }
  };
}

export function endBreak(): EndBreakAction {
  return {
    type: END_BREAK
  };
}

export function endBreakSuccess(shift: Shift): EndBreakSuccessAction {
  return {
    type: END_BREAK_SUCCESS,
    payload: {
      shift
    }
  };
}

export function clockOut(): ClockOutAction {
  return {
    type: CLOCK_OUT
  };
}

export function clockOutSuccess(shift: Shift): ClockOutSuccessAction {
  return {
    type: CLOCK_OUT_SUCCESS,
    payload: {
      shift
    }
  };
}

export function startAdHocClockIn(shift: Shift | null): StartAdHocClockInAction {
  return {
    type: START_AD_HOC_CLOCK_IN,
    payload: {
      shift
    }
  };
}

export function adHocClockIn(
  locationId: IDNumber,
  positionId: IDNumber,
  timeClockNote: string
): AdHocClockInAction {
  return {
    type: AD_HOC_CLOCK_IN,
    payload: {
      locationId,
      positionId,
      timeClockNote
    }
  };
}

export function adHocClockInSuccess(shift: Shift): AdHocClockInSuccessAction {
  return {
    type: AD_HOC_CLOCK_IN_SUCCESS,
    payload: {
      shift
    }
  };
}

export function getTimeClockStateFinished(): GetTimeClockStateFinishedAction {
  return {
    type: GET_TIME_CLOCK_STATE_FINISHED
  };
}

export function addOrEditTimeclockNote(
  shiftId: IDString,
  note: string
): AddOrEditTimeclockNoteAction {
  return {
    type: ADD_OR_EDIT_TIMECLOCK_NOTE,
    payload: {
      shiftId,
      note
    }
  };
}

export function addOrEditTimeclockNoteSuccess(note: string): AddOrEditTimeclockNoteSuccessAction {
  return {
    type: ADD_OR_EDIT_TIMECLOCK_NOTE_SUCCESS,
    payload: {
      note
    }
  };
}

export function setHideGreeting(isGreetingVisible: boolean): SetHideGreetingAction {
  return {
    type: SET_HIDE_GREETING,
    payload: {
      isGreetingVisible
    }
  };
}

export function clockOutWithAttestations(
  shiftId: string,
  attestations: Array<Object>
): ClockOutWithAttestationsAction {
  return {
    type: CLOCK_OUT_WITH_ATTESTATIONS,
    payload: {
      shiftId,
      attestations
    }
  };
}
